import React from 'react';
import Helmet from 'react-helmet';

// types
import type { WCmsPageImageView } from '@zola/svc-web-api-ts-client';

export type HeroCustomizationHeadProps = {
  images?: WCmsPageImageView[];
  inPreview?: boolean;
};

const fallbackImg =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png';

const HeroCustomizationHead: React.FC<HeroCustomizationHeadProps> = ({ images, inPreview }) => {
  if (inPreview) return null;
  return (
    <Helmet
      meta={[{ name: 'og:image', content: (images && images[0]?.image_url) || fallbackImg }]}
    />
  );
};

export default HeroCustomizationHead;
